/* eslint-disable react/jsx-one-expression-per-line */
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import MenusNav from '@base/MenusNav/MenusNav';
import { menus } from '@utils/constants';
import { Fonts, Spacings } from '@styles/index';
import H2 from '@base/H2/H2';
import Layout from '@layout/index';
import LeftContainer from '@cont/CompanyDetails/LeftContainer';
import RightContainer from '@cont/CompanyDetails/RightContainer';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import H3 from '@base/H3/H3';

const Line = styled.li`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.P1};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: var(--color-text-primary);
  margin: 0px;
`;

const StyledH3 = styled(H3)`
  margin: ${Spacings.SPACING_6B} 0;
`;

const Terms = () => {
  const { pathname, query } = useRouter();
  return (
    <>
      <LeftContainer>
        <MenusNav data={menus} currentHref={pathname} />
      </LeftContainer>
      <RightContainer>
        {query.in_app !== 'true' && (
          <H2 as="h1">Unacademy Credits - Terms and Conditions</H2>
        )}
        <br />
        <br />
        <br />
        <StyledH3>Preliminary</StyledH3>
        <ol>
          <Line>
            &quot;Credits&quot; is a feature introduced on Unacademy Platform
            for paid and unpaid Users. Credits are in the nature of loyalty
            points for use of various offers, products and services that may be
            made available through the Platform.
          </Line>
          <Line>
            The following terms (&quot;<strong>Credit Terms</strong>&quot;) are
            part of and subject to the Platform Term(s) including any
            modifications, alterations or updates thereof, that may be published
            on the Platform from time to time.
          </Line>
        </ol>
        <StyledH3>Eligibility</StyledH3>
        <ol>
          <Line>To earn Credits, you must be a Learner on the Platform.</Line>
          <Line>
            As a Learner, you should have registered and created an account on
            the Platform in accordance with our Platform Terms.
          </Line>
          <Line>
            Eligibility to earn Credits depends on offer applicability and
            instructions and Platform Term(s) as amended and/or supplemented by
            Unacademy from time to time.
          </Line>
          <Line>
            Different Users might be able to see/avail different offers at the
            same point of time. Unacademy has the right to show the most
            relevant offers for the Users.
          </Line>
          <Line>
            Every offer has a budget. Accordingly, any offer may be removed by
            us (at our discretion) prior to the expiry of the offer.
          </Line>
        </ol>
        <StyledH3>Earning of Credits</StyledH3>
        <ol>
          <Line>
            Credits can be earned through multiple actions / activities on the
            Platform including but not limited to-
            <ol type="a">
              <Line>Signing-up on the Platform;</Line>
              <Line>Answering practice questions;</Line>
              <Line>
                Maintaining a learning streak by watching any class; and
              </Line>
              <Line>performing a task on the Platform</Line>
            </ol>
          </Line>
          <Line>
            Unacademy may, at its sole discretion, introduce new actions /
            activities where the Credits can be earned.
          </Line>
          <Line>
            Number of Credits that can be earned in a particular offer are
            subject to terms and conditions of that particular offer and the
            Platform Terms.
          </Line>
          <Line>
            The Platform does not permit any purchase or accrual of these
            Credits in any other way.
          </Line>
        </ol>
        <StyledH3>Expiry Of Credits</StyledH3>
        <ol>
          <Line>
            Credits will expire after 1 year from the date of credit of the
            Credits or such other time as decided by Unacademy, in its sole
            discretion.
          </Line>
        </ol>
        <StyledH3>Redemption</StyledH3>
        <ol>
          <Line>
            For the purpose of rewards redemption, the value of 1 Credit is
            equivalent to 1 Rupee. Unacademy reserves the right to modify this
            at any point in time without prior notice.
          </Line>
          <Line>
            Credits can be redeemed for services / products on the Platform for{' '}
            <i>inter alia</i> purchase, renewal, and upgrade of subscriptions on
            the Platform.
          </Line>
          <Line>
            Per transaction will have a limitation on the number of Credits that
            can be used.
          </Line>
          <Line>
            Credits cannot be converted to cash or used in lieu of cash.
          </Line>
          <Line>Credits once used cannot be reversed.</Line>
          <Line>
            Credits do not have any monetary value and customer will not be
            eligible for any monetary compensation in lieu of settlement against
            Credits including in case of loss of Credits.
          </Line>
        </ol>
        <StyledH3>General Terms and Conditions</StyledH3>
        <ol>
          <Line>
            Unacademy reserves the right to modify or cancel or prematurely
            remove an offer in its entirety without prior notice. Similarly,
            Unacademy reserves the right to modify, add or delete any of the
            terms under this Credit Terms at any point of time at its sole
            discretion without serving any prior intimation. Intimation of any
            change, modification, addition, deletion in the Terms will be
            updated on this page or in the relevant section of the Platform.
          </Line>
          <Line>
            Credits are non-transferable; non-endorsable; non- exchangeable for
            equivalent amount of money or anything of value. Unacademy does not
            promise/promote to do the same.
          </Line>
          <Line>
            Credits are time-bound, and accordingly the same must be availed
            within the duration specified on the Platform and/or as communicated
            to you in writing (emails included).
          </Line>
          <Line>
            Unacademy reserves the right to cancel, revoke, or otherwise prevent
            the issuance of Credits in any suspected case of fraudulent use or
            misuse of Credit Terms. Spam and/or illegal emails are not
            permitted.
          </Line>
          <Line>
            Unacademy reserves the right to disqualify any User, who does not
            meet the offer requirements or in case of reasons including but not
            limited to any misuse of the offer or fraud or suspicious
            transaction/activity or under any legal requirement or applicable
            rules and regulations, from receiving any Credit or cancel any
            Credit already earned or credited.
          </Line>
          <Line>
            In case of a dispute, the final decision to credit / modify the
            Credits lies with Unacademy.
          </Line>
          <Line>
            Nothing contained herein shall be construed as a binding obligation
            on Unacademy to continue Credits or to substitute Credits by a
            similar or a new scheme.
          </Line>
          <Line>
            Redemption of Credits is voluntary, and all related charges shall be
            deemed to be voluntarily incurred by a User.
          </Line>
          <Line>
            The User shall not hold Unacademy responsible for any actions,
            claims, demands, liabilities, losses, damages, costs, charges or
            expenses, which a User incurs, in normal course of availing the
            Credits.
          </Line>
          <Line>
            Unacademy reserves the right to suspend the issue of Credits to you
            personally, or to all users temporarily or permanently at any time
            without notice.
          </Line>
          <Line>
            These Credits Terms shall be in addition to and not in
            substitution/derogation of the Platform Term(s).
          </Line>
        </ol>
      </RightContainer>
    </>
  );
};

Terms.pageInfo = {
  name: 'Unacademy Credits Terms',
  isMWebSupported: true,
  layoutOptions: {
    disableDarkMode: true
  }
};

export default Terms;
Terms.Layout = Layout;
Terms.Wrapper = PageReduxProvider;
